import React from 'react';
import {Field} from 'redux-form';

import {ImageSelectField} from 'components/Fields';
import FormField from 'components/FormField';
import Label from 'components/Label';

import {selectLocation} from 'ducks/locations';

import {required} from 'utils/validators';

const buildLocationSelectizeOption = location => {
  return {
    value: location.id,
    label: location.name,
    url: location.thumbnailImage
  };
};

export const initialValues = state => {
  const location = selectLocation(state);

  return {
    location: location && buildLocationSelectizeOption(location)
  };
};

const LocationSection = ({location}) => (
  <FormField>
    <Label>Location</Label>
    {location && (
      <Field
        name="location"
        validate={[required]}
        component={ImageSelectField}
        options={[buildLocationSelectizeOption(location)]}
        disabled={true}
      />
    )}
  </FormField>
);

export default LocationSection;
